import AppPage from '../../mixins/app-page'

import AppNewsletter from '../app-newsletter'
import AppTokenPracEarned from '../app-token-prac-earned'

import SimpleGridExperience from '../../libs/experience/SimpleGridExperience'

export default
{
    name: 'page-token',

    mixins: [
        AppPage
    ],

    components: {
        AppNewsletter,
        AppTokenPracEarned
    },

    data() {
        return {
            mobileOrientation: null,
            mobileOrientationBackup: null,
            containerPositionsGot: false,
            visualizationPosition: null,
            economicsPosition: null,
            spriteContainerPosition: null,
            sprite: {
                numberOfImages: 59,
                currentImageIndex: 0,
                positions: {
                    scale: {
                        minimum: 0,
                        maximum: 29
                    },
                    rotation: {
                        minimum: 30,
                        maximum: 58
                    }
                },
                state: 'created'
            },
            earnCanvasStep: 0,
            user1Active: false,
            user1Prax: 0,
            user2Active: false,
            user2Prax: 0.110
        }
    },

    created() {
        this.frame = 0

        this.sprite.positions.scale.middle = ((this.sprite.positions.scale.maximum - this.sprite.positions.scale.minimum) / 2) + this.sprite.positions.scale.minimum
        this.sprite.positions.rotation.middle = ((this.sprite.positions.rotation.maximum - this.sprite.positions.rotation.minimum) / 2) + this.sprite.positions.rotation.minimum

        this.mouse = {
            x: 0,
            y: 0,
            xEasing: 0,
            yEasing: 0,
            moved: false
        }

        this.orientation = {
            x: 0,
            isActive: false
        }

        this.eventHub.$on('application:onEnterFrame', this.onEnterFrame)

        if (window.DeviceOrientationEvent) {
            window.addEventListener('deviceorientation', this.onDeviceOrientation)
        }
    },

    mounted() {
        this.$el.addEventListener('mousemove', this.onMousemove)
        this.eventHub.$on('window:resize', this.onResize)

        this.$logotypeSprites = this.$el.querySelectorAll('.js-logotype-sprite')
        this.$logotypeSpriteContainer = this.$el.querySelector('.js-logotype-sprite-container')
        this.$economicsContainer = this.$el.querySelector('.js-economics-container')
        this.$titlesDisappear = this.$el.querySelectorAll('.js-titles-disappear')

        this.setScenes()
        this.onResize()
    },

    destroyed() {
        this.$el.removeEventListener('mousemove', this.onMousemove)
        this.eventHub.$off('window:resize', this.onResize)

        this.eventHub.$off('application:onEnterFrame', this.onEnterFrame)

        this.$background = this.$el.querySelector('.js-background')
        this.experience = new SimpleGridExperience()
        this.experience.renderer.domElement.classList.add('p-token__experience')
        this.experience.renderer.domElement.classList.add('u-absolute')
        this.experience.renderer.domElement.classList.add('u-pos-tl')

        this.$background.appendChild(this.experience.renderer.domElement)
    },

    methods: {
        clickOnEarnCanvas() {
            if (this.earnCanvasStep === 0) {
                this.earnCanvasStep = 1
            } else if (this.earnCanvasStep === 1) {
                this.earnCanvasStep = 0
            }
        },

        /* Mouse events */
        onMousemove(event) {
            this.mouse.x = event.clientX
            this.mouse.y = event.clientY
            this.mouse.moved = true
        },
        /* ***** */

        /* Sprite */
        moveSpriteForIntroduction() {
            this.sprite.currentImageIndex = 0
            this.sprite.state = 'rotationRunning'
        },
        /* ***** */

        /* Windows event */
        onResize() {
            this.mobileOrientationBackup = this.mobileOrientation
            this.mobileOrientation = this.$root.width < this.$root.height ? 'portrait' : 'landscape'

            if (this.$root.isTouch) {
                if (!this.containerPositionsGot || this.mobileOrientation !== this.mobileOrientationBackup) {
                    this.getContainerPositions()
                }
            } else if (!this.$root.isTouch) {
                this.getContainerPositions()
            }
            
            // Scenes
            this.scenes.limit1 = this.$refs.scene1.getBoundingClientRect().top + this.$root.currScrollTop - this.$root.height * 0.5
            this.scenes.limit2 = this.$refs.scene2.getBoundingClientRect().top + this.$root.currScrollTop - this.$root.height * 0.5
            
            let ratio = this.scenes.$parent1.offsetWidth / this.scenes.baseWidth
            
            if (ratio > 0.95) {
                ratio = 1
            }
            this.scenes.$scene1.style.transform = `scale(${ratio})`
            this.scenes.$scene2.style.transform = `scale(${ratio})`
        },

        onDeviceOrientation(event) {
            this.orientation.x = event.gamma
            this.orientation.isActive = true
        },
        /* ***** */

        /* onEnterFrame */
        onEnterFrame() {
            this.frame += 1

            this.mouse.xEasing += (this.mouse.x - this.mouse.xEasing) * 0.1
            this.mouse.yEasing += (this.mouse.y - this.mouse.yEasing) * 0.1

            if (!this.sprite.moveSpriteForIntroductionCalled && !this.isFirstLoading && this.$root.routingStep === 3) {
                this.sprite.moveSpriteForIntroductionCalled = true
                setTimeout(this.moveSpriteForIntroduction, 800)
            } else if (!this.sprite.moveSpriteForIntroductionCalled && !this.isFirstLoading && this.$root.routingStep === 0) {
                this.sprite.moveSpriteForIntroductionCalled = true
                setTimeout(this.moveSpriteForIntroduction, 800)
            }

            if (this.sprite.state === 'introductionRunning') {
                if (this.frame % 2 === 0) {
                    this.sprite.currentImageIndex += 1
                }

                const percent = this.sprite.currentImageIndex / this.sprite.positions.scale.maximum

                const opacityFrom = 0
                const opacityTo = 1
                const opacity = opacityFrom - ((opacityFrom - opacityTo) * percent)

                if (percent >= 1) {
                    this.sprite.currentImageIndex = this.sprite.positions.rotation.middle

                    this.sprite.state = 'rotationRunning'
                }

                this.$logotypeSprites[0].style.transform = `translateX(${this.sprite.currentImageIndex * 100 / this.sprite.numberOfImages * -1}%) translateZ(0)`

                this.$logotypeSprites[0].style.opacity = opacity
            } else if (this.sprite.state === 'rotationRunning') {
                if (this.mouse.moved || this.$root.isTouch) {
                    const limitX = this.$root.width / 2 / 100 * 75
                    const percentX = this.$root.isTouch ? Math.min(Math.max(this.orientation.x / 90 * 2 * -1, -1), 1) : Math.min(Math.max((this.mouse.xEasing - (this.$root.width / 2)) / limitX, -1), 1)

                    if (percentX > 0) {
                        this.sprite.currentImageIndex = this.sprite.positions.rotation.middle + ((this.sprite.positions.rotation.maximum - this.sprite.positions.rotation.middle) * percentX)
                    } else if (percentX < 0) {
                        this.sprite.currentImageIndex = this.sprite.positions.rotation.middle - ((this.sprite.positions.rotation.middle - this.sprite.positions.rotation.minimum) * (percentX * -1))
                    } else {
                        this.sprite.currentImageIndex = this.sprite.positions.rotation.middle
                    }

                    this.sprite.currentImageIndex = Math.round(this.sprite.currentImageIndex)

                    if (this.sprite.currentImageIndex >= this.sprite.positions.rotation.maximum) {
                        this.sprite.currentImageIndex = this.sprite.positions.rotation.maximum
                    } else if (this.sprite.currentImageIndex <= this.sprite.positions.rotation.minimum) {
                        this.sprite.currentImageIndex = this.sprite.positions.rotation.minimum
                    }
                } else {
                    this.sprite.currentImageIndex = this.sprite.positions.rotation.middle
                }

                this.$logotypeSprites.forEach(el => {
                    el.style.transform = `translateX(${this.sprite.currentImageIndex * 100 / this.sprite.numberOfImages * -1}%) translateZ(0)`
                })
            }
            
            this.visualizationPosition = 2000
            // console.log(this.visualizationPosition)
            if (this.visualizationPosition) {
                if (this.$root.currScrollTop > 0) {
                    const scrollRatio = this.$root.currScrollTop / this.$root.height
                    
                    // Logo opacity
                    let logoOpacity = 2 - scrollRatio * 3.5
                    logoOpacity = Math.min(Math.max(logoOpacity, 0), 1)
                    this.$logotypeSpriteContainer.style.opacity = logoOpacity
                    
                    // Logo scale
                    let logoScale = 1 + scrollRatio
                    logoScale = Math.min(Math.max(logoScale, 1), 1.2)
                    this.$logotypeSpriteContainer.style.transform = `scale(${logoScale}) translateY(${this.$root.currScrollTop}px) translateZ(0)`

                    // Titles opacity
                    this.$titlesDisappear.forEach(el => {
                        let opacity = 1 - scrollRatio * 12 + parseFloat(el.dataset.opacityOffset, 10)
                        opacity = Math.min(Math.max(opacity, 0), 1)

                        el.style.opacity = Math.round(opacity * 100) / 100
                    })
                }
            }

            if (this.economicsPosition) {
                const economicContainer = this.$economicsContainer

                if (!economicContainer) return

                if (this.$root.currScrollTop > economicContainer.getBoundingClientRect().top + (economicContainer.offsetHeight * 2)) {
                    economicContainer.classList.add('is-active')
                } else {
                    economicContainer.classList.remove('is-active')
                }
            }
            
            // Scenes
            const user1Active = this.$root.currScrollTop > this.scenes.limit1
            const user2Active = this.$root.currScrollTop > this.scenes.limit2
            
            if (user1Active !== this.user1Active) {
                this.user1Active = user1Active
                window.setTimeout(() => {
                    this.user1Prax = this.user1Active ? 0.015 : 0
                }, 1100)
            }
            
            if (user2Active !== this.user2Active) {
                this.user2Active = user2Active
                window.setTimeout(() => {
                    this.user2Prax = this.user2Active ? 0.095 : 0.110
                }, 300)
                
                window.clearInterval(this.scenes.interval1)
                window.clearInterval(this.scenes.interval2)
                
                if (this.user2Active) {
                    this.scenes.interval1 = window.setInterval(() => {
                        this.user2Prax -= 0.004
                        
                        if (this.user2Prax < 0) {
                            this.user2Prax = 0.110
                        }
                    }, 3000)
                    
                    window.setTimeout(() => {
                        this.scenes.interval2 = window.setInterval(() => {
                            this.user2Prax -= 0.004
                        
                            if (this.user2Prax < 0) {
                                this.user2Prax = 0.110
                            }
                        }, 3000)
                    }, 1000)
                }
            }
            
            const rotateY = (this.mouse.xEasing / this.$root.width - 0.5) * 10
            const rotateX = -(this.mouse.yEasing / this.$root.height - 0.5) * 10 - 7

            this.scenes.$pivot1.style.transform = `rotateY(${rotateY}deg) rotateX(${rotateX}deg)`
            this.scenes.$pivot2.style.transform = `rotateY(${rotateY}deg) rotateX(${rotateX}deg)`
        },
        /* ***** */

        getContainerPositions() {
            if (this.$el.querySelector('.js-economics-container')) {
                this.economicsPosition = this.$el.querySelector('.js-economics-container').getBoundingClientRect().top
            }

            if (this.$el.querySelector('.js-logotype-sprite-container')) {
                this.spriteContainerPosition = this.$el.querySelector('.js-logotype-sprite-container').getBoundingClientRect().top
            }

            this.containerPositionsGot = true
        },

        scrollTo(value) {
            const offset = 140
            if (value) this.eventHub.$emit('page:scroll-to', value - offset)
        },
        
        setScenes() {
            this.scenes = {}
            
            this.scenes.baseWidth = 800
            
            this.scenes.$scene1 = this.$refs.scene1
            this.scenes.$scene2 = this.$refs.scene2
            
            this.scenes.$parent1 = this.scenes.$scene1.parentElement
            this.scenes.$parent2 = this.scenes.$scene2.parentElement
            
            this.scenes.$pivot1 = this.scenes.$scene1.querySelector('.js-token-scene-pivot')
            this.scenes.$pivot2 = this.scenes.$scene2.querySelector('.js-token-scene-pivot')

            this.scenes.limit1 = Infinity
            this.scenes.limit2 = Infinity
            
            this.scenes.interval1 = null
            this.scenes.interval2 = null
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-token/script.js